// eslint-disable-next-line import/no-named-as-default
import MyReservations from './MyReservations';

export default MyReservations;
